import $http from '@/api';
import store from '@/store';
import isArray from 'lodash/isArray';

export function getPopulateFieldsForCompositionModule(entityId, entity, {
  triggerPopulationField,
  contextCompositionId,
  moduleType,
  slotType,
  moduleTemplate,
  draft = {},
}) {
  const id = isArray(entityId) ? entityId[0] : entityId;
  return $http.post(`/api/entity/${entity}/${id}/populateFields`, {
    entity: 'composition',
    entityId: contextCompositionId,
    triggerPopulationField,
    moduleType,
    slotType,
    moduleTemplate,
    draft,
  });
}

export function getPopulateFieldsForRelation(entityId, entity, {
  triggerPopulationField,
  contextEntity,
  contextEntityId,
  relationType,
  draft = {},
}) {
  const id = isArray(entityId) ? entityId[0] : entityId;
  return $http.post(`/api/entity/${entity}/${id}/populateFields`, {
    entity: contextEntity,
    entityId: contextEntityId,
    triggerPopulationField,
    relationType,
    draft,
  });
}

export function getPopulateFields(entityId, entity, {
  triggerPopulationField,
  contextEntity,
  contextEntityId,
  draft = {},
  wizard = null,
}) {
  const id = isArray(entityId) ? entityId[0] : entityId;
  return $http.post(`/api/entity/${entity}/${id}/populateFields`, {
    entity: contextEntity,
    entityId: contextEntityId,
    triggerPopulationField,
    draft,
    wizard,
  });
}

export default function factory(entity) {
  const apiPath = store.getters.getEntityApiPath(entity) || `/api/${entity}`;
  const fetch = async (id, relativeVersionId) => (
    relativeVersionId
      ? $http.get(`${apiPath}/${id}/versions/${relativeVersionId}/editor`)
      : $http.get(`${apiPath}/${id}/editor`)
  );
  const remove = async id => $http.delete(`${apiPath}/${id}`);
  const update = async (id, versionId, payload) => (
    versionId
      ? $http.patch(`${apiPath}/${id}/versions/${versionId}/editor`, payload)
      : $http.patch(`${apiPath}/${id}/editor`, payload)
  );
  const create = async payload => $http.post(`${apiPath}`, payload);
  const publish = async (id, versionId) => (
    versionId
      ? $http.post(`${apiPath}/${id}/versions/${versionId}/publish`)
      : $http.post(`${apiPath}/${id}/publish`)
  );
  const unpublish = async id => $http.post(`${apiPath}/${id}/unpublish`);
  const preview = async id => $http.get(`/api/entity/${entity}/${id}/preview`);
  const moreInfo = async id => $http.get(`/api/entity/${entity}/${id}/more-info`);
  const clone = async (id, versionId) => $http.post(`${apiPath}/${id}/versions/${versionId}/clone`);
  const versions = async (id, page = 1, limit = 20) => $http.post(`${apiPath}/${id}/versions`, { page, limit });
  const previewPaywall = async (id, versionId) => $http.post(`${apiPath}/${id}/versions/${versionId}/redirect_to_select_user_paywall_version`);
  const previewPaywallCondition = async conditionId => $http.post(`/api/entity/conditionPaywall/${conditionId}/redirect_to_select_user_paywall_version_condition`);
  const previewPaywallMessage = async messageId => $http.post(`/api/entity/conditionPaywall/${messageId}/redirect_to_select_user_paywall_version_condition_message`);
  const breadcrumb = async id => $http.get(`/api/entity/${entity}/${id}/breadcrumb`);
  const children = async id => $http.get(`/api/entity/${entity}/${id}/children`);


  return {
    fetch,
    remove,
    update,
    create,
    publish,
    unpublish,
    preview,
    moreInfo,
    clone,
    versions,
    previewPaywall,
    previewPaywallCondition,
    previewPaywallMessage,
    breadcrumb,
    children,
  };
}
